var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/fork-awesome-icon.tsx";
const _excluded = ["id", "className", "fixedWidth"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * ForkAwesomeIcon: renders a ForkAwesome icon.
 * Full list: https://forkaweso.me/Fork-Awesome/icons/
 * @module soapbox/components/fork_awesome_icon
 * @see soapbox/components/icon
 */
import classNames from 'clsx';
import React from 'react';

const ForkAwesomeIcon = _ref => {
  let {
    id,
    className,
    fixedWidth
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  // Use the Fork Awesome retweet icon, but change its alt
  // tag. There is a common adblocker rule which hides elements with
  // alt='retweet' unless the domain is twitter.com. This should
  // change what screenreaders call it as well.
  // const alt = (id === 'retweet') ? 'repost' : id;
  return /*#__PURE__*/React.createElement("i", _extends({
    role: "img" // alt={alt}
    ,
    className: classNames('fa', "fa-".concat(id), className, {
      'fa-fw': fixedWidth
    })
  }, rest, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 5
    }
  }));
};

export default ForkAwesomeIcon;